import { ProjectSlug } from '@monoimin/sb-types';

export const ENABLE_DRAFT_MODE = process.env['ENABLE_DRAFT_MODE'] === 'true';

export const IS_DEV = process.env['NODE_ENV'] === 'development';

export const IS_PROD = process.env['NODE_ENV'] === 'production';

export const IS_TEST = process.env['NODE_ENV'] === 'test';

export const IS_MAIN_BRANCH = process.env['NEXT_PUBLIC_IS_MAIN'] === 'true';

export const IS_VERCEL_PROD =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

export const IS_STRAPI_DEV = process.env['NEXT_PUBLIC_STRAPI_DEV'] === 'true';
export const STAGING_DOMAIN = process.env['NEXT_PUBLIC_STAGING_DOMAIN'];
export const GENERATE_ALL_PAGES = process.env['GENERATE_ALL_PAGES'] === 'true';
export const PROD_DOMAIN = process.env['NEXT_PUBLIC_PROD_DOMAIN'];
export const VERCEL_PROJECT_PRODUCTION_URL =
  process.env['NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL'];
export const IS_GOLDEN_VISA =
  PROD_DOMAIN === 'mygoldenvisa.io' ||
  STAGING_DOMAIN === 'mgv-main.mygoldenvisa.io';
export const VERCEL_BRANCH_URL = process.env['NEXT_PUBLIC_VERCEL_BRANCH_URL'];

export const AI_PODCAST_WEBHOOK_URL =
  process.env['AI_PODCAST_WEBHOOK_URL'] || '';

export const IS_TRAILING_SLASH_ENABLED =
  process.env['NEXT_PUBLIC_TRAILING_SLASH'] === 'true';

export const PROJECT_SLUG = process.env[
  'NEXT_PUBLIC_PROJECT_SLUG'
] as ProjectSlug;

export const LOAD_SCRIPTS = process.env['LOAD_SCRIPTS'] === 'true';

export const RENTA_DOMAIN = process.env['NEXT_PUBLIC_RENTA_DOMAIN'];

export const RENTA_WRITE_KEY = process.env['NEXT_PUBLIC_RENTA_WRITE_KEY'];

export const VERCEL_ENV = process.env['NEXT_PUBLIC_VERCEL_ENV'];

export const OPEN_ANALYZER = process.env['OPEN_ANALYZER'] === 'true';

export const ANALYZE = process.env['ANALYZE'] === 'true';

export const VERCEL_GIT_COMMIT_REF = process.env['VERCEL_GIT_COMMIT_REF'];

export const NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF =
  process.env['NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF'];

export const ENABLE_VWO = process.env['NEXT_PUBLIC_ENABLE_VWO'] === 'true';

export const ENABLE_AMPLITUDE =
  process.env.NEXT_PUBLIC_ENABLE_AMPLITUDE === 'true';

export const GOOGLE_API_KEY = process.env['GOOGLE_API_KEY'];

export const NEXT_PUBLIC_YEAR_FOR_REPLACEMENT =
  process.env['NEXT_PUBLIC_YEAR_FOR_REPLACEMENT'];

export const KV_COUNTRY_CODES_KV_REST_API_URL =
  process.env['KV_COUNTRY_CODES_KV_REST_API_URL'];
export const KV_COUNTRY_CODES_KV_REST_API_READ_ONLY_TOKEN =
  process.env['KV_COUNTRY_CODES_KV_REST_API_READ_ONLY_TOKEN'];
export const REDIRECTS_TEST_KV_REST_API_URL =
  process.env['REDIRECTS_TEST_KV_REST_API_URL'];
export const REDIRECTS_TEST_KV_REST_API_READ_ONLY_TOKEN =
  process.env['REDIRECTS_TEST_KV_REST_API_READ_ONLY_TOKEN'];
export const USE_SERVER_FORM_SUBMIT =
  process.env['NEXT_PUBLIC_USE_SERVER_FORM_SUBMIT'] === 'true';

export const IS_ANALYTICS_ENABLED =
  process.env['NEXT_PUBLIC_ENABLE_ANALYTICS'] === 'true';
// Размер в байтах
export const NEXT_PUBLIC_MAX_FILE_SIZE =
  Number(process.env['NEXT_PUBLIC_MAX_FILE_SIZE']) || 25 * 1024 * 1024; // 25MB
export const DISABLE_GRAVITY_FORMS_CACHE =
  process.env['DISABLE_GRAVITY_FORMS_CACHE'] === 'true';
export const IS_CTA_FEATURE = process.env['ENABLE_CTA_FEATURE'] === 'true';
export const DEFAULT_READING_TIME_MIN = 7;
